module.exports = __webpack_public_path__ + "img/icon_vip_aiqiyi@2x.2001a3c0.png";